import accountSettingsEnLocales from './en/account-settings.json'
import accountSettingsEsLocales from './es/account-settings.json'
import accountSettingsPtLocales from './pt/account-settings.json'
import commonEnLocales from './en/common.json'
import commonEsLocales from './es/common.json'
import commonEsPaLocales from './es-pa/common.json'
import commonPtLocales from './pt/common.json'
import companySettingsEnLocales from './en/company-settings.json'
import companySettingsEsLocales from './es/company-settings.json'
import companySettingsPtLocales from './pt/company-settings.json'
import dashboardEnLocales from './en/dashboard.json'
import dashboardEsLocales from './es/dashboard.json'
import dashboardPtLocales from './pt/dashboard.json'
import fieldSettingsEnLocales from './en/field-settings.json'
import fieldSettingsEsLocales from './es/field-settings.json'
import fieldSettingsPtLocales from './pt/field-settings.json'
import loginEnLocales from './en/login.json'
import loginEsLocales from './es/login.json'
import loginPtLocales from './pt/login.json'
import lotDashboardEnLocales from './en/lot-dashboard.json'
import lotDashboardEsLocales from './es/lot-dashboard.json'
import lotDashboardEsPaLocales from './es-pa/lot-dashboard.json'
import lotDashboardPtLocales from './pt/lot-dashboard.json'
import lotSettingsEnLocales from './en/lot-settings.json'
import lotSettingsEsLocales from './es/lot-settings.json'
import lotSettingsPtLocales from './pt/lot-settings.json'
import mapEnLocales from './en/map.json'
import mapEsLocales from './es/map.json'
import mapPtLocales from './pt/map.json'
import navbarEnLocales from './en/navbar.json'
import navbarEsLocales from './es/navbar.json'
import navbarPtLocales from './pt/navbar.json'
import seasonSettingsEnLocales from './en/season-settings.json'
import seasonSettingsEsLocales from './es/season-settings.json'
import seasonSettingsPtLocales from './pt/season-settings.json'
import settingsEnLocales from './en/settings.json'
import settingsEsLocales from './es/settings.json'
import settingsPtLocales from './pt/settings.json'
import internalMetricsEnLocales from './en/internal-metrics.json'
import internalMetricsEsLocales from './es/internal-metrics.json'
import internalMetricsPtLocales from './pt/internal-metrics.json'
import onboardingEsLocales from './es/onboarding.json'
import onboardingEnLocales from './en/onboarding.json'
import onboardingPtLocales from './pt/onboarding.json'
import lotsManagementEsLocales from './es/lots-management.json'
import lotsManagementEnLocales from './en/lots-management.json'
import lotsManagementPtLocales from './pt/lots-management.json'

export const Locales = {
  accountSettingsEnLocales,
  accountSettingsEsLocales,
  accountSettingsPtLocales,
  commonEnLocales,
  commonEsLocales,
  commonEsPaLocales,
  commonPtLocales,
  companySettingsEnLocales,
  companySettingsEsLocales,
  companySettingsPtLocales,
  dashboardEnLocales,
  dashboardEsLocales,
  dashboardPtLocales,
  fieldSettingsEnLocales,
  fieldSettingsEsLocales,
  fieldSettingsPtLocales,
  loginEnLocales,
  loginEsLocales,
  loginPtLocales,
  lotDashboardEnLocales,
  lotDashboardEsLocales,
  lotDashboardEsPaLocales,
  lotDashboardPtLocales,
  lotSettingsEnLocales,
  lotSettingsEsLocales,
  lotSettingsPtLocales,
  mapEnLocales,
  mapEsLocales,
  mapPtLocales,
  navbarEnLocales,
  navbarEsLocales,
  navbarPtLocales,
  seasonSettingsEnLocales,
  seasonSettingsEsLocales,
  seasonSettingsPtLocales,
  settingsEnLocales,
  settingsEsLocales,
  settingsPtLocales,
  internalMetricsEnLocales,
  internalMetricsEsLocales,
  internalMetricsPtLocales,
  onboardingEsLocales,
  onboardingEnLocales,
  onboardingPtLocales,
  lotsManagementEsLocales,
  lotsManagementEnLocales,
  lotsManagementPtLocales,
}
